import Grid from "@mui/material/Grid";

// Components
import { useAuth } from "hooks/auth.hook";
import { loginRequest } from "configs/MsalConfig";
import Spinner from "components/Spinner";
import HierarchyPage from "pages/Client/ClientDetailView";

/**
 * HomePage Component
 *
 * This component renders the home page of the application. It checks if the user is authenticated
 * and displays the locations or a spinner based on the authentication state.
 *
 * @returns {JSX.Element} The rendered HomePage component.
 */
const HomePage = () => {
  const accessToken = useAuth(loginRequest);
  // Remove Highlights
  localStorage.removeItem("Highlights");
  localStorage.setItem("HighlightsMenu", "Location Details");
  return (
    <Grid container spacing={2}>
      {accessToken ? (
        // <DisplayLocations />
        <HierarchyPage/>
      ) : (
        <Spinner size={80} data-testid="spinner" />
      )}
    </Grid>
  );
};

export default HomePage;
